import { Box, CircularProgress } from "@mui/material";
import { Text } from "@src/lib/ui-react";
import { type ReactElement } from "react";
import { Link } from "react-router-dom";

const fullScreenCenterSx = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
} as const;

const cardSx = (theme: {
  spacing: (a: number, b: number) => string;
  palette: { background: { paper: string } };
}) => ({
  padding: theme.spacing(6, 8),
  width: 420,
  minHeight: 300,
  backgroundColor: theme.palette.background.paper,
  borderRadius: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

interface Props {
  error: string | undefined;
}

export function RipplingSsoCallbackView({ error }: Props): ReactElement {
  return (
    <Box sx={(theme) => ({ ...fullScreenCenterSx, backgroundColor: theme.palette.grey[900] })}>
      <Box sx={cardSx}>
        <img
          alt="Clipboard"
          height={70}
          src={`${import.meta.env.BASE_URL}assets/clipboard-wordmark-brown.png`}
          style={{ width: "auto" }}
        />
        {error ? (
          <Box
            sx={(theme) => ({
              marginTop: theme.spacing(4),
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: theme.spacing(3),
              width: "100%",
            })}
          >
            <Text color="error" sx={{ textAlign: "center" }}>
              {error}
            </Text>
            <Link to="/enter" style={{ fontSize: 14 }}>
              Back to Login
            </Link>
          </Box>
        ) : (
          <Box
            sx={(theme) => ({
              marginTop: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: theme.spacing(3),
              width: "100%",
            })}
          >
            <CircularProgress />
            <Text>Signing in...</Text>
          </Box>
        )}
      </Box>
    </Box>
  );
}
